module.exports = __webpack_public_path__ + "img/telegram.32408460.svg";